
/*
 * My Home Plant – Pflanzen-Mix
 * Deutsche Texte und Euro-Preisformate
 * Ausschließlich für Essenify Mix & Match
 */

(() => {
  const rootSelector = '.essenify-mam-container';

  const currencyFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  });

  function translatePrices(root) {
    const selectors = [
  '.essenify-mam-product-price',
  '.essenify-mam-price-val',
  '.essenify-mam-original-price',
  '.essenify-mam-rule-badge'
];

    root.querySelectorAll(selectors.join(',')).forEach(element => {
      const value = element.textContent.trim();

      // Bereits korrekt formatierte Preise ignorieren
      if (/[\d],\d{2}\s*€/.test(value)) return;

      // Formate wie "€ 69.95" oder "EUR 69.95"
      const match = value.match(
        /^(?:€|EUR)\s*([\d,]+)\.(\d{2})$/
      );

      if (!match) return;

      const amount = Number(
        match[1].replace(/,/g, '') + '.' + match[2]
      );

      if (Number.isFinite(amount)) {
        element.textContent = currencyFormatter.format(amount);
      }
    });
  }

  function translateLabels(root) {
    // Pflichtauswahl pro Kategorie
    root.querySelectorAll('.mam-category-rule-badge').forEach(badge => {
      const match = badge.textContent.trim()
        .match(/^Add (\d+) items?$/i);

      if (!match) return;

      const quantity = Number(match[1]);

      badge.textContent = quantity === 1
        ? '1 Pflanze auswählen'
        : `${quantity} Pflanzen auswählen`;
    });

    // Mengenangabe der gewählten Pflanzen
    root.querySelectorAll('.essenify-mam-slot-qty').forEach(element => {
      const match = element.textContent.trim()
        .match(/^Qty\s*x\s*(\d+)$/i);

      if (match) {
        element.textContent = `Menge: ${match[1]}`;
      }
    });

    // Ausverkaufte Pflanzen
    root.querySelectorAll('.essenify-mam-product-card button')
      .forEach(button => {
        if (button.textContent.trim().toLowerCase() === 'sold out') {
          button.textContent = 'Ausverkauft';
        }
      });
  }

  function updateBundle(root) {
    translateLabels(root);
    translatePrices(root);
  }

  function initialize() {
    const root = document.querySelector(rootSelector);
    if (!root) return false;

    let scheduled = false;

    const refresh = () => {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        updateBundle(root);
      });
    };

    refresh();

    new MutationObserver(refresh).observe(root, {
      childList: true,
      characterData: true,
      subtree: true
    });

    return true;
  }

  if (!initialize()) {
    const startupObserver = new MutationObserver(() => {
      if (initialize()) startupObserver.disconnect();
    });

    startupObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
